import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_HLWN_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PAGE_HLWN_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_HLWN_80,
  },
  {
    pageId: PageId.UPSELL_HLWN_80,
  },
  {
    pageId: PageId.DOWNLOAD_HLWN_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
